<template>
  <div style="width: 100%; padding-bottom: env(safe-area-inset-bottom); box-shadow: none !important; background-color: transparent !important;">
    <v-bottom-navigation
    	class="transparent"
      v-model="value"
      elevation="0"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'ALUMNO'"
    >
      <v-btn :to="{ name: 'GruposAlumnos' }" icon v-if="getDatosUsuarioLMS">
        <span>Home</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Perfil' }" icon v-if="getDatosUsuarioLMS">
        <span>Perfil</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <!-- <v-btn :to="{ name: 'Chat' }" icon v-if="getDatosUsuarioLMS">
        <span>Chat</span>

        <v-icon>mdi-chat</v-icon>
      </v-btn> -->

      <v-btn :to="{ name: 'Tickets' }" icon>
        <span>Soporte</span>

        <v-icon>mdi-headphones-settings</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'TEACHER'"
    >
      <v-btn :to="{ name: 'GruposTeacher' }" icon>
        <span>Grupos</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'PerfilTeacher' }" icon>
        <span>Perfil</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Tickets' }" icon>
        <span>Soporte</span>

        <v-icon>mdi-headphones-settings</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'EDITOR'"
    >
      <v-btn :to="{ name: 'PerfilEditor' }" icon>
        <span>Perfil</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

  </div>
</template>
<script>
  // Librerías
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data: () => ({
      value: 0,
    }),

    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),
    	salir(){
        this.salirLogin()
    	}
    },

    computed: {
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),

      color () {
        switch (this.value) {
          case 0: return 'primary'
          case 1: return '#157C72'
          case 2: return 'orange'
          case 3: return 'indigo'
          default: return 'blue-grey'
        }
      },
    },
  }
</script>

<style scope>
.v-bottom-navigation {
  box-shadow: none !important;
  /* Opcional, para evitar borde o sombra */
  background-color: transparent !important; /* si quieres que sea transparente */
}
</style>
